<footer>
  <div class="footer-desc">
    <div routerLink="home" routerLinkActive="active" class="footer-logo">
      <img src="assets/logo.png" alt="Logo" />
    </div>

    <div>
      <p class="footer-mob-nav" (click)="toggleMenu()">
        {{ "footer.title" | translate }}
        <span class="arrow">&#8595;</span>
      </p>

      <p class="footer-text">
        <a routerLink="home" routerLinkActive="active">{{
          "nav.main" | translate
        }}</a>
      </p>
      <p class="footer-text">
        <a routerLink="about" routerLinkActive="active">{{
          "nav.about" | translate
        }}</a>
      </p>
      <p class="footer-text">
        <a routerLink="offers" routerLinkActive="active">{{
          "nav.offer" | translate
        }}</a>
      </p>
      <p class="footer-text">
        <a routerLink="references" routerLinkActive="active">{{
          "nav.ref" | translate
        }}</a>
      </p>
      <p class="footer-text">
        <a routerLink="policy" routerLinkActive="active">{{
          "nav.policy" | translate
        }}</a>
      </p>
      <p class="footer-text">
        <a routerLink="/contact" routerLinkActive="active">{{
          "nav.contact" | translate
        }}</a>
      </p>
    </div>

    <div class="footer-mob-contact">
      <p class="footer-mob-con" (click)="toggleContact()">
        {{ "nav.contact" | translate }} <span class="arrow">&#8595;</span>
      </p>
    </div>

    <div class="footer-mob-data">
      <p class="footer-mob-dat" onclick="toggleMenu('menu-data')">
        <span class="arrow">&#8595;</span>
      </p>
      <div class="footer-contact">
        <p>email: <a href="mailto:omex@omex.pl">omex&#64;omex.pl</a></p>
        <p>tel: +48 505 050 515</p>
        <p>tel: +48 505 050 525</p>
        <br />
      </div>
      <div class="footer-details menu-hidden" id="menu-data">
        <p>Omex Sp. z o.o. Sp. k.</p>
        <p>Sąd Rejonowy Gdańsk-Północ</p>
        <p>KRS: 0000375262</p>
        <p>NIP: 586-226-32-14</p>
        <p>REGON: 221160244</p>
      </div>
    </div>
  </div>

  <div class="footer-politic">
    <span class="mob-text"> All rights reserved Omex © 2025</span>
  </div>
</footer>
